/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Nav_SessionsInputs */

const en_ui_nav_sessions = /** @type {(inputs: Ui_Nav_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions`)
};

const de_ui_nav_sessions = /** @type {(inputs: Ui_Nav_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten`)
};

/**
* | output |
* | --- |
* | "Sessions" |
*
* @param {Ui_Nav_SessionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_nav_sessions = /** @type {((inputs?: Ui_Nav_SessionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Nav_SessionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_nav_sessions(inputs)
	return de_ui_nav_sessions(inputs)
});